import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { compareWeekKeys, getWeeklySchedule, WEEK_ORDER } from '../fedex-location-weekly-schedule.util';
import { KeyValue } from '@angular/common';
import { LocationEntry, TimeRange } from '@evorait/pace-core';

@Component({
    selector: 'pace-material-fedex-locations-expandable',
    templateUrl: './material-fedex-locations-expandable.component.html',
    styleUrls: ['./material-fedex-locations-expandable.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MaterialFedexLocationsExpandableComponent {
    @Input() public fedexLocation: LocationEntry;
    @Output() public selectFedexLocationEvent = new EventEmitter<LocationEntry>();

    public isCollapsed = true;
    protected readonly faChevronDown = faChevronDown;
    protected readonly faChevronUp = faChevronUp;
    protected readonly getWeeklySchedule = getWeeklySchedule;

    public selectFedexLocation(event: Event): void {
        event.stopPropagation();
        this.selectFedexLocationEvent.emit(this.fedexLocation);
    }

    public compareKeys(a: KeyValue<string, TimeRange>, b: KeyValue<string, TimeRange>): number {
        return compareWeekKeys(a, b, WEEK_ORDER);
    }
}
